interface ITimezone {
  timezoneId: string;
  offset: string;
}

const Timezones: ITimezone[] = [
  { timezoneId: "America/Bogota", offset: "-05:00" },
  { timezoneId: "America/Chihuahua", offset: "-06:00" },
  { timezoneId: "America/Mexico_City", offset: "-06:00" },
  { timezoneId: "America/Tijuana", offset: "-08:00" },
  { timezoneId: "Etc/GMT-9", offset: "-09:00" },
  { timezoneId: "Asia/Irkutsk", offset: "+08:00" },
  { timezoneId: "Etc/GMT-12", offset: "+12:00" },
  { timezoneId: "Asia/Kolkata", offset: "+05:30" },
  { timezoneId: "Asia/Krasnoyarsk", offset: "+07:00" },
  { timezoneId: "Asia/Magadan", offset: "+11:00" },
  { timezoneId: "Asia/Novosibirsk", offset: "+07:00" },
  { timezoneId: "Etc/GMT-6", offset: "-06:00" },
  { timezoneId: "Asia/Taipei", offset: "+08:00" },
  { timezoneId: "Asia/Vladivostok", offset: "+10:00" },
  { timezoneId: "Asia/Yakutsk", offset: "+09:00" },
  { timezoneId: "Asia/Yekaterinburg", offset: "+05:00" },
  { timezoneId: "Australia/Adelaide", offset: "+09:30" },
  { timezoneId: "Australia/Brisbane", offset: "+10:00" },
  { timezoneId: "Australia/Darwin", offset: "+09:30" },
  { timezoneId: "Australia/Hobart", offset: "+10:00" },
  { timezoneId: "Australia/Perth", offset: "+08:00" },
  { timezoneId: "Australia/Hobart", offset: "+10:00" },
  { timezoneId: "Etc/GMT-4", offset: "-04:00" },
  { timezoneId: "Europe/Berlin", offset: "+01:00" },
  { timezoneId: "Europe/Bucharest", offset: "+02:00" },
  { timezoneId: "Europe/Berlin", offset: "+01:00" },
  { timezoneId: "Europe/Bucharest", offset: "+02:00" },
  { timezoneId: "Etc/GMT-3", offset: "-03:00" },
  { timezoneId: "Etc/GMT-2", offset: "-02:00" },
  { timezoneId: "Europe/Bucharest", offset: "+02:00" },
  { timezoneId: "Europe/London", offset: "+00:00" },
  { timezoneId: "Europe/Minsk", offset: "+03:00" },
  { timezoneId: "Europe/Moscow", offset: "+03:00" },
  { timezoneId: "Europe/Paris", offset: "+01:00" },
  { timezoneId: "Etc/GMT", offset: "+00:00" },
  { timezoneId: "Etc/GMT-4", offset: "-04:00" },
  { timezoneId: "Etc/GMT-4", offset: "-04:00" },
  { timezoneId: "Europe/Warsaw", offset: "+01:00" },
  { timezoneId: "America/Chicago", offset: "-06:00" },
  { timezoneId: "America/New_York", offset: "-05:00" },
  { timezoneId: "US/Arizona", offset: "-07:00" },
  { timezoneId: "America/Los_Angeles", offset: "-08:00" },
];

export function TimezoneIdToOffset(timezoneId: string = ""): string {
  const selectedTimezone = Timezones.find((item) => item.timezoneId === timezoneId);

  if (selectedTimezone) return selectedTimezone.offset;
  else return "-00:00";
}
